import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { ProcessCard } from "./ProcessCard.jsx";
import { SkeletonCarousel } from "./SkeletonCarousel.jsx";
import { Modal } from "react-bootstrap";
export function ProcessListWidget({ configuration }) {
  const [processes, setProcesses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false); 
  
  const closeModal = () => setIsModalOpen(false);
  const openModal = () => setIsModalOpen(true);

  useEffect(() => {
    getProcesses();
  }, []);

  const headers = {
    "Accept-Language": window.location.pathname.split("/")[1],
  };

  const getProcesses = async () => {
    setIsLoading(true);
    fetch(configuration.endpoint, { headers: headers })
      .then((response) => response.json())
      .then((data) => {
        setProcesses(data.results);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  let title;
  if (configuration.finished) {
    title = configuration.translations.finishedProcesses;
  } else if (configuration.future) {
    title = configuration.translations.futureProcesses;
  } else if (configuration.mine) {
    title = configuration.translations.myProcesses;
  } else {
    title = configuration.translations.activeProcesses;
  }

  let out;
  if (processes.length > 0) {
    out = (
      <div className="container" id="ProcessListWidget">
        <h3 className="section__title--float h4">{title}</h3>
        <Slider
          {...configuration.settings}
          infinite={processes.length > configuration.settings.slidesToShow}
        >
          {processes.map((process) => (
            <div key={process.pk}>
              <ProcessCard
                process={process}
                configuration={configuration}
                openModal={openModal}
              />
            </div>
          ))}
        </Slider>
      </div>
    );
  } else {
    out = (
      <div className="container" id="ProcessListWidget">
        <h3 className="section__title--float h4">{title}</h3>
        <div className="min-height-13em">
          <p className="section__description--float my-5">{configuration.translations.emptyMessages}</p>
        </div>
      </div>
    );
  }

  return (
    <>
      {isLoading ? <SkeletonCarousel /> : out}
      {/* Modal */}
      {isModalOpen && 
        <Modal show={isModalOpen} onHide={closeModal} className="SuggestionForm">
          <Modal.Header closeButton className="bg-light">
            <Modal.Title>{configuration.translations.forbiddenProcess}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{configuration.translations.forbiddenProcessExplication}</p>
            <span>{configuration.translations.forbiddenProcessTry}</span>
            <ul>
              <li>{configuration.translations.forbiddenProcessList1}</li>
              <li>{configuration.translations.forbiddenProcessList2}</li>
              <li>{configuration.translations.forbiddenProcessList3}</li>
            </ul>
          </Modal.Body>
        </Modal>
      }
    </>
  );
}
